import React from 'react';
import PropTypes from 'prop-types';
import { UX2 } from '@wsb/guac-widget-core';
import { RouteHandler } from '@wsb/guac-widget-shared/lib/common/ols-core/core-bundle';

import CategoryLink from './CategoryLink';
import dataAids from '../../../constants/dataAids';
import styles from './styles';
import { mapContextToProps } from '../OlsShopContext';

export function AllProducts(props) {
  const {
    Element: { ListItem, Block }
  } = UX2;
  const {
    allProductsInfo,
    selectedTaxonPermalink,
    isSearch,
    routePath,
    onClick,
    separator = false,
    bottomSpace = false,
    overflowHidden = false,
    desktop = false,
    translate
  } = props;
  const { position = 0 } = allProductsInfo;
  const ELEMENT = !desktop ? Block : ListItem;
  const mobileStyles = {
    ...styles.linkContainer,
    ...(separator ? styles.separator : {}),
    ...(bottomSpace ? styles.bottom : {})
  };
  const name = allProductsInfo.name || translate('products.view_all');
  // 'All Products' should only be selected when the following conditions are true:
  // 1. There is no selected permalink
  const notSelectedPermalink = !selectedTaxonPermalink;

  // 2. We're not rendering search results
  const notSearch = !isSearch;

  // 3. List position is 0 -or- routePath is specifically 'all'
  const specificPosition = position === 0 || routePath === RouteHandler.ALL_PRODUCTS_ROUTE;

  return (
    <ELEMENT
      key='view-all'
      data-aid={ dataAids.CATEGORY_VIEW_ALL }
      style={ !desktop ? mobileStyles : {} }
    >
      <CategoryLink
        isAllProducts
        name={ name }
        isSelected={ notSelectedPermalink && notSearch && specificPosition }
        onClick={ onClick }
        overflowHidden={ overflowHidden }
      />
    </ELEMENT>
  );
}

AllProducts.propTypes = {
  allProductsInfo: PropTypes.object,
  selectedTaxonPermalink: PropTypes.string,
  isSearch: PropTypes.bool,
  routePath: PropTypes.string,
  onClick: PropTypes.func,
  separator: PropTypes.bool,
  bottomSpace: PropTypes.bool,
  overflowHidden: PropTypes.bool,
  desktop: PropTypes.bool,
  translate: PropTypes.func
};

AllProducts.defaultProps = {
  translate: () => {}
};

export default mapContextToProps(AllProducts, context => ({
  translate: context.translate
}));
